var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"transform":"translateY(300px)"},attrs:{"id":"alert"}},[_c('div',{staticClass:"inner",on:{"click":_vm.close}},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.str))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-bell fa-sm"})])
}]

export { render, staticRenderFns }